import Icon from '../components/Icon.vue'

Icon.register({
  cannabis: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M503.5 360.3c5.2 2.8 8.5 8.2 8.5 14.2 0 5.9-3.3 11.4-8.5 14.1-2.5 1.3-60.8 31.7-133.5 31.7-6.1 0-12-0.1-17.5-0.3 11.4 22.2 16.5 38.3 16.8 39.2 1.8 5.7 0.3 11.9-3.9 16.1-2.6 2.6-7.7 4.7-11.3 4.7-1.3 0-3.5-0.3-4.8-0.7-1.8-0.6-37.7-12-77.3-39.3v64c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-64c-39.6 27.3-75.5 38.7-77.3 39.3-1.3 0.4-3.4 0.7-4.8 0.7-3.7 0-8.8-2.1-11.3-4.7-4.2-4.2-5.7-10.4-3.9-16.1 0.3-0.9 5.4-17 16.8-39.2-5.5 0.2-11.4 0.3-17.5 0.3-72.7 0-131-30.4-133.5-31.7-4.7-2.5-8.5-8.8-8.5-14.1 0-5.3 3.8-11.7 8.5-14.2 1.6-0.8 32.4-16.9 76.8-25.8-64.3-75.1-84-161.7-84.9-165.6-0.2-0.9-0.4-2.5-0.4-3.5 0-3.7 2.1-8.7 4.7-11.3 3-3 7.1-4.7 11.3-4.7 1.1 0 2.3 0.1 3.4 0.4 3.9 0.9 86.6 19.6 160.6 79.8 0-1.5 0-2.9 0-4.4 0-118.8 60-213.7 62.5-217.7 2.9-4.6 8-7.4 13.5-7.4h0c4.8 0 10.9 3.3 13.5 7.4 2.5 4 62.5 98.9 62.5 217.7 0 1.5 0 2.9 0 4.4 74-60.2 156.7-78.9 160.6-79.8 1.2-0.3 2.3-0.4 3.4-0.4 4.2 0 8.3 1.7 11.3 4.7 3.9 3.9 5.5 9.4 4.3 14.8-0.9 4-20.7 90.5-84.9 165.6 44.4 8.9 75.2 25 76.8 25.8z'
      }
    ]
  }
})
